import {DateRange, ShiftQuickSelectSlots} from '@hconnect/common/types'
import {getQuickSelectFilter} from '@hconnect/common/utils'
import {isString} from 'lodash'
import moment, {Moment} from 'moment-timezone'

import {useConfigData} from '../../shared/hooks'

import {useTimeRangeParam} from './useTimeRangeParam'

type OptimizationSpecialistTimeRangeResult = {
  start?: Moment
  end?: Moment
  rawTimeRange: DateRange | ShiftQuickSelectSlots
}

export const useOptimizationSpecialistTimeRange = (): OptimizationSpecialistTimeRangeResult => {
  const {shifts, timezone} = useConfigData()
  const {timeRange} = useTimeRangeParam({
    defaultTimeRange: 'pastShift',
    key: 'timeRange',
    timezone: timezone
  })

  const isQuickSelectSlots = isString(timeRange)
  if (isQuickSelectSlots) {
    const timeRangeSelectSlot = timeRange
    const [startDate, endDate] = getQuickSelectFilter(
      timeRangeSelectSlot,
      shifts,
      moment().tz(timezone)
    )

    return {
      start: startDate,
      end: endDate,
      rawTimeRange: timeRangeSelectSlot
    }
  }

  const {startDate, endDate}: DateRange = timeRange
  return {
    start: startDate,
    end: endDate,
    rawTimeRange: timeRange
  }
}
